// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3Y9QI","title":"AfterBackImages_title__1TmHt","images":"AfterBackImages_images__3vV6k"};